<template>
	<v-card
		:color="color"
		dark
	>
		<v-card-title class="py-1 text-h6">
			<span>
				{{ title }}
				<span
					v-if="submissionUserInfo"
				>
					[{{ submissionUserInfo }}]
				</span> - {{ submission.formattedDateSubmitted }}
			</span>
			<span v-if="isMergedRecord">
				{{ "\xa0" }}(Merged!)
			</span>
			<v-spacer />
			<v-btn
				v-if="canSeePreferences"
				icon
				@click="expanded = !expanded"
			>
				<v-icon>
					{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
				</v-icon>
			</v-btn>
		</v-card-title>
		<v-card-text
			v-show="expanded"
			class="white text--primary"
		>
			<div class="pt-4">
				<v-expand-transition>
					<div>
						<DataSubjectSubmission
							:submission="submission"
							:syrenis-id="syrenisId"
							:can-see-preferences="canSeePreferences"
							:can-see-contact-details="canSeeContactDetails"
							:is-merged-record="isMergedRecord"
							v-bind="item"
						/>
					</div>
				</v-expand-transition>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import DataSubjectSubmission from './data-subject-submission.vue'
import { auditHistoryExpandedByDefault } from '../../../../../../shared/state/configuration.js'
import { RESERVED_EXTENDED_PREFERENCE_LABELS } from '../../../../../../shared/enums/extended-preferences.js'
export default {
	name: 'data-subject-audit-history-timeline-card',
	components: { DataSubjectSubmission },
	props: {
		item: Object,
		color: String,
		title: String,
		canSeePreferences: Boolean,
		canSeeContactDetails: Boolean,
		submission: Object,
		submissionIndex: Number,
		syrenisId: Number,
		groupedProfileIds: Array,
		dataSubjectPreferences: Array
	},
	setup () {
		return {
			auditHistoryExpandedByDefault
		}
	},
	data () {
		return {
			expanded: false
		}
	},
	computed: {
		isMergedRecord () {
			return this.syrenisId !== this.submission.syrenisId && (!Array.isArray(this.groupedProfileIds) || !this.groupedProfileIds.includes(this.submission.syrenisId))
		},
		submissionUserInfo () {
			// Check if it's a CS Portal Submission
			if (this.submission.submissionSource === 'Vue CS Portal' &&
				this.submission.submittedPreferences &&
				this.submission.submittedPreferences.length > 0) {
				// Look through all preferences in the submission to find one with a GUID
				for (const submittedPreference of this.submission.submittedPreferences) {
					if (!submittedPreference.submissionGuid) continue

					// If we have a GUID, check if there's a matching preference with extended preferences
					if (this.dataSubjectPreferences && this.dataSubjectPreferences.length > 0) {
						const preference = this.dataSubjectPreferences.find(pref => {
							const match = pref.submissionGUID === submittedPreference.submissionGuid &&
								pref.extendedPreferences &&
								pref.extendedPreferences.length > 0
							return match
						})
						if (preference && preference.extendedPreferences) {
							// Look for extended preferences with agent username and user ID
							const userId = preference.extendedPreferences.find(ext => ext.key === RESERVED_EXTENDED_PREFERENCE_LABELS.AGENT_USER_ID)?.value
							const username = preference.extendedPreferences.find(ext => ext.key === RESERVED_EXTENDED_PREFERENCE_LABELS.AGENT_USERNAME)?.value

							if (username && userId) {
								return `${username} (ID: ${userId})`
							}
						}
					}
				}
			}
			return null
		}
	},
	created () {
		if (this.submissionIndex + 1 <= auditHistoryExpandedByDefault.value) {
			this.expanded = true
		}
	}
}
</script>
